export { default as BigNav } from "./BigNav";
export { default as Buttons } from "./Buttons";
export { default as TabDetail } from "./TabDetail";
export { default as Tabs } from "./Tabs";
